function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1996(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 17.12,
    height: 9.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5416666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 4.625
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.25,
    width: 17.12,
    height: 9.92,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.417142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 14.21
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19.17,
    width: 17.12,
    height: 10.25,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4642857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 24.295
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 29.42,
    width: 17.12,
    height: 11.03,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.103
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 34.935
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40.45,
    width: 17.12,
    height: 12.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.56875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 46.725
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 53,
    width: 17.12,
    height: 13.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0361538461538462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 59.735
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 66.47,
    width: 17.12,
    height: 14.23,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 73.585
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 80.7,
    width: 17.12,
    height: 14.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4283333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 87.985
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 95.27,
    width: 17.12,
    height: 16.9,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.414285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 103.72
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 112.17,
    width: 17.12,
    height: 18.36,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4240000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 121.35
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 130.53,
    width: 17.12,
    height: 18.7,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 139.88
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 149.23,
    width: 17.12,
    height: 21.9,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 160.17999999999998
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 171.13,
    width: 17.12,
    height: 22.67,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 182.465
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 193.8,
    width: 17.12,
    height: 22.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 205.16500000000002
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 216.54,
    width: 17.12,
    height: 23.26,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4457142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 228.17
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 239.8,
    width: 17.12,
    height: 24.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 251.95000000000002
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 264.1,
    width: 17.12,
    height: 24.55,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 276.375
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 288.65,
    width: 17.12,
    height: 24.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 301.075
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 313.5,
    width: 17.12,
    height: 25.55,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 326.275
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 339.05,
    width: 17.12,
    height: 26.42,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 352.26
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 365.47,
    width: 17.12,
    height: 27.62,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4457142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 379.28000000000003
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 393.08,
    width: 17.12,
    height: 28.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4457142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 407.12
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 421.16,
    width: 17.12,
    height: 29.21,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 435.76500000000004
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 450.37,
    width: 17.12,
    height: 29.67,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 465.205
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 480.04,
    width: 17.12,
    height: 30.57,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 495.32500000000005
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 510.6,
    width: 17.12,
    height: 30.67,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4457142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 525.9350000000001
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 541.27,
    width: 17.12,
    height: 31.14,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.4457142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 556.84
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 572.41,
    width: 17.12,
    height: 31.42,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 588.12
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 603.83,
    width: 17.12,
    height: 31.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4240000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 619.63
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 635.43,
    width: 17.12,
    height: 31.62,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4240000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 651.2399999999999
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 667.06,
    width: 17.12,
    height: 32.94,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4457142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.56,
    y: 683.53
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 0,
    width: 21.79,
    height: 25.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6316666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 28.015,
    y: 12.975
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.91,
    y: 0,
    width: 22.06,
    height: 25.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.206
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.94,
    y: 12.975
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.97,
    y: 0,
    width: 22.63,
    height: 25.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2328571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 72.285,
    y: 12.975
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.6,
    y: 0,
    width: 23.36,
    height: 25.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.672
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.28,
    y: 12.975
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.96,
    y: 0,
    width: 24.14,
    height: 25.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.448571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.03,
    y: 12.975
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.1,
    y: 0,
    width: 24.89,
    height: 25.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5557142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.545,
    y: 12.975
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.99,
    y: 0,
    width: 24.9,
    height: 25.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 168.44,
    y: 12.975
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.89,
    y: 0,
    width: 25.49,
    height: 25.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.18625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.635,
    y: 12.975
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.38,
    y: 0,
    width: 25.55,
    height: 25.95,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.258333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 219.155,
    y: 12.975
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.93,
    y: 0,
    width: 25.96,
    height: 25.95,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 244.91,
    y: 12.975
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257.88,
    y: 0,
    width: 26.57,
    height: 25.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.165,
    y: 12.975
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.45,
    y: 0,
    width: 26.89,
    height: 25.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.895,
    y: 12.975
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311.34,
    y: 0,
    width: 27.17,
    height: 25.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.24375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.92499999999995,
    y: 12.975
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.51,
    y: 0,
    width: 27.37,
    height: 25.95,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.707142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 352.195,
    y: 12.975
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.88,
    y: 0,
    width: 27.58,
    height: 25.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 379.67,
    y: 12.975
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 393.45,
    y: 0,
    width: 27.99,
    height: 25.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.4875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.445,
    y: 12.975
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.44,
    y: 0,
    width: 28.32,
    height: 25.95,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.24375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.6,
    y: 12.975
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 449.76,
    y: 0,
    width: 29.46,
    height: 25.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 464.49,
    y: 12.975
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.22,
    y: 0,
    width: 29.85,
    height: 25.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.24375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 494.14500000000004,
    y: 12.975
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.07,
    y: 0,
    width: 31.14,
    height: 25.95,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 524.64,
    y: 12.975
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.21,
    y: 0,
    width: 31.23,
    height: 25.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5949999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 555.825,
    y: 12.975
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 571.44,
    y: 0,
    width: 31.34,
    height: 25.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5949999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.11,
    y: 12.975
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 602.78,
    y: 0,
    width: 32.11,
    height: 25.95,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8833333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.8349999999999,
    y: 12.975
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.89,
    y: 0,
    width: 32.13,
    height: 25.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.4875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.955,
    y: 12.975
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 667.02,
    y: 0,
    width: 32.98,
    height: 25.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 683.51,
    y: 12.975
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 25.95,
    width: 31.43,
    height: 27.49,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.581666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 39.695
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 53.44,
    width: 31.43,
    height: 27.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5280000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 67.25999999999999
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 81.08,
    width: 31.43,
    height: 27.72,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.465
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 94.94
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 108.81,
    width: 31.43,
    height: 27.72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.62
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 122.67
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 136.53,
    width: 31.43,
    height: 28.34,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 150.7
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 164.87,
    width: 31.43,
    height: 28.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.087142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 179.175
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 193.48,
    width: 31.43,
    height: 29.2,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.866666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 208.07999999999998
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 222.68,
    width: 31.43,
    height: 30.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.164
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 238.09
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 253.5,
    width: 31.43,
    height: 30.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.4071428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 268.925
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 284.35,
    width: 31.43,
    height: 31.28,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.213333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 299.99
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 315.63,
    width: 31.43,
    height: 31.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.8575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 331.46
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 347.28,
    width: 31.43,
    height: 32.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 363.40999999999997
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 379.54,
    width: 31.43,
    height: 32.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 395.70500000000004
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 411.87,
    width: 31.43,
    height: 34.58,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.49
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 429.16
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 446.45,
    width: 31.43,
    height: 34.9,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.238333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 463.9
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 481.35,
    width: 31.43,
    height: 35.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.49
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 498.865
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 516.39,
    width: 31.43,
    height: 35.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 534.35
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 552.3,
    width: 31.43,
    height: 36.61,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.92875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 570.6049999999999
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 588.92,
    width: 31.43,
    height: 36.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 607.3
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 625.67,
    width: 31.43,
    height: 36.94,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.92875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 644.14
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.12,
    y: 662.61,
    width: 31.43,
    height: 37.39,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.835,
    y: 681.3050000000001
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 25.95,
    width: 32.41,
    height: 36.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.05125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 64.755,
    y: 44.315
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.96,
    y: 25.95,
    width: 33.22,
    height: 36.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.644
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.57,
    y: 44.315
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.18,
    y: 25.95,
    width: 33.54,
    height: 36.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.708
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.95000000000002,
    y: 44.315
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.72,
    y: 25.95,
    width: 33.61,
    height: 36.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7344444444444442
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.525,
    y: 44.315
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.33,
    y: 25.95,
    width: 33.98,
    height: 36.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.663333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 198.32000000000002,
    y: 44.315
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.32,
    y: 25.95,
    width: 34.08,
    height: 36.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.868571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.35999999999999,
    y: 44.315
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.39,
    y: 25.95,
    width: 35.89,
    height: 36.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.178
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.335,
    y: 44.315
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.28,
    y: 25.95,
    width: 36.28,
    height: 36.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.628
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 303.41999999999996,
    y: 44.315
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321.57,
    y: 25.95,
    width: 36.38,
    height: 36.73,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.276000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 339.76,
    y: 44.315
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.94,
    y: 25.95,
    width: 36.71,
    height: 36.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.078888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 376.295,
    y: 44.315
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.65,
    y: 25.95,
    width: 36.78,
    height: 36.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.121666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.03999999999996,
    y: 44.315
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 431.42,
    y: 25.95,
    width: 36.91,
    height: 36.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.121666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.875,
    y: 44.315
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.33,
    y: 25.95,
    width: 37.05,
    height: 36.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.59125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.85499999999996,
    y: 44.315
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505.38,
    y: 25.95,
    width: 37.79,
    height: 36.73,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.243333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 524.275,
    y: 44.315
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.17,
    y: 25.95,
    width: 38.1,
    height: 36.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.247142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.2199999999999,
    y: 44.315
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 581.27,
    y: 25.95,
    width: 39.18,
    height: 36.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.345999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.86,
    y: 44.315
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.45,
    y: 25.95,
    width: 39.44,
    height: 36.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.247142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.1700000000001,
    y: 44.315
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 659.89,
    y: 25.95,
    width: 40.11,
    height: 36.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.345999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 679.9449999999999,
    y: 44.315
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 62.68,
    width: 40.01,
    height: 36.86,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.686
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 81.11
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 99.54,
    width: 40.01,
    height: 36.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.153333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 118
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 136.46,
    width: 40.01,
    height: 37.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 154.98000000000002
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 173.51,
    width: 40.01,
    height: 37.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 192.135
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 210.76,
    width: 40.01,
    height: 37.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.248333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 229.505
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 248.25,
    width: 40.01,
    height: 37.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 267.225
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 286.2,
    width: 40.01,
    height: 37.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.5920000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 305.18
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 324.17,
    width: 40.01,
    height: 37.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.331666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 343.165
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 362.16,
    width: 40.01,
    height: 38.2,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 381.26000000000005
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 400.36,
    width: 40.01,
    height: 39.83,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 420.27500000000003
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 440.19,
    width: 40.01,
    height: 42.5,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.00125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 461.44
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 482.69,
    width: 40.01,
    height: 42.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.001999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 504.095
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 525.5,
    width: 40.01,
    height: 42.96,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.668333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 546.98
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 568.46,
    width: 40.01,
    height: 43.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.668333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 589.97
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 611.48,
    width: 40.01,
    height: 43.31,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.715714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 633.135
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.55,
    y: 654.79,
    width: 40.01,
    height: 45.21,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.668333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.55499999999999,
    y: 677.395
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.56,
    y: 62.68,
    width: 40.62,
    height: 46.24,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 108.87,
    y: 85.8
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.18,
    y: 62.68,
    width: 40.79,
    height: 46.24,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.532222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 149.57500000000002,
    y: 85.8
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.97,
    y: 62.68,
    width: 41.98,
    height: 46.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.664444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.96,
    y: 85.8
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.95,
    y: 62.68,
    width: 43.75,
    height: 46.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.825,
    y: 85.8
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.7,
    y: 62.68,
    width: 44.02,
    height: 46.24,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 277.71,
    y: 85.8
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.72,
    y: 62.68,
    width: 44.15,
    height: 46.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.0375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 321.795,
    y: 85.8
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.88,
    y: 62.68,
    width: 46.06,
    height: 46.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.90999999999997,
    y: 85.8
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.94,
    y: 62.68,
    width: 47.67,
    height: 46.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.706666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.775,
    y: 85.8
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 437.61,
    y: 62.68,
    width: 48.76,
    height: 46.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.56
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.99,
    y: 85.8
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 486.37,
    y: 62.68,
    width: 49.88,
    height: 46.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.706666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 511.31,
    y: 85.8
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 536.24,
    y: 62.68,
    width: 51.65,
    height: 46.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.605714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.065,
    y: 85.8
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.89,
    y: 62.68,
    width: 53.09,
    height: 46.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.706666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.435,
    y: 85.8
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 640.98,
    y: 62.68,
    width: 59.02,
    height: 46.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.605714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.49,
    y: 85.8
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.56,
    y: 108.92,
    width: 58.95,
    height: 47.15,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.735714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.035,
    y: 132.495
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.56,
    y: 156.07,
    width: 58.95,
    height: 52.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.035,
    y: 182.35
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.56,
    y: 208.63,
    width: 58.95,
    height: 53.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.612857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.035,
    y: 235.275
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.56,
    y: 261.93,
    width: 58.95,
    height: 54.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.051666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.035,
    y: 289.08500000000004
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.56,
    y: 316.24,
    width: 58.95,
    height: 55.84,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.306666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.035,
    y: 344.16
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.56,
    y: 372.08,
    width: 58.95,
    height: 57.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.448
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.035,
    y: 400.7
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.56,
    y: 429.32,
    width: 58.95,
    height: 63.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.825000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.035,
    y: 461.135
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.56,
    y: 492.95,
    width: 58.95,
    height: 63.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.36875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.035,
    y: 524.83
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.56,
    y: 556.71,
    width: 58.95,
    height: 65.18,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.825000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.035,
    y: 589.3000000000001
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.56,
    y: 621.89,
    width: 58.95,
    height: 78.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.790000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.035,
    y: 660.9449999999999
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 108.92,
    width: 64.27,
    height: 71.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.18142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.635,
    y: 144.775
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.77,
    y: 108.92,
    width: 64.7,
    height: 71.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.242857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 244.12,
    y: 144.775
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.47,
    y: 108.92,
    width: 64.84,
    height: 71.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.204444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.89000000000004,
    y: 144.775
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.32,
    y: 108.92,
    width: 67.46,
    height: 71.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.4325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 375.05,
    y: 144.775
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.77,
    y: 108.92,
    width: 68.27,
    height: 71.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.378333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.905,
    y: 144.775
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.05,
    y: 108.92,
    width: 68.83,
    height: 71.71,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.832857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 511.46500000000003,
    y: 144.775
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 545.88,
    y: 108.92,
    width: 75.43,
    height: 71.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.341999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.595,
    y: 144.775
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.31,
    y: 108.92,
    width: 78.69,
    height: 71.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.244285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.655,
    y: 144.775
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 180.64,
    width: 74.23,
    height: 78.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.371666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.615,
    y: 219.89999999999998
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 259.15,
    width: 74.23,
    height: 80.03,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.247777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.615,
    y: 299.16499999999996
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 339.18,
    width: 74.23,
    height: 83.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.615,
    y: 380.92
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 422.66,
    width: 74.23,
    height: 91,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.27875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.615,
    y: 468.16
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 513.66,
    width: 74.23,
    height: 92.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.5575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.615,
    y: 559.915
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147.5,
    y: 606.17,
    width: 74.23,
    height: 93.83,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.604285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.615,
    y: 653.0849999999999
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.74,
    y: 180.64,
    width: 71.12,
    height: 99.52,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.16
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 257.3,
    y: 230.39999999999998
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.86,
    y: 180.64,
    width: 82.84,
    height: 99.52,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.355
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 334.28000000000003,
    y: 230.39999999999998
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.7,
    y: 180.64,
    width: 99.05,
    height: 99.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.38125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 425.22499999999997,
    y: 230.39999999999998
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 474.75,
    y: 180.64,
    width: 106.94,
    height: 99.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 528.22,
    y: 230.39999999999998
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 581.69,
    y: 180.64,
    width: 118.31,
    height: 99.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.217142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.845,
    y: 230.39999999999998
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.74,
    y: 280.16,
    width: 147.78,
    height: 82.02,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.2525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.63,
    y: 321.17
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.74,
    y: 362.18,
    width: 147.78,
    height: 102.8,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.685714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.63,
    y: 413.58
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.74,
    y: 464.98,
    width: 147.78,
    height: 235.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.4725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.63,
    y: 582.49
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.52,
    y: 280.16,
    width: 162.54,
    height: 263.01,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 40.635
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 450.78999999999996,
    y: 411.665
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 532.06,
    y: 280.16,
    width: 167.94,
    height: 263.01,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 27.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 616.03,
    y: 411.665
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.52,
    y: 543.17,
    width: 330.48,
    height: 156.83,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 26.138333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 534.76,
    y: 621.5849999999999
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1996);
export default __webpack_public_path__ + "static/media/1996.5f59f55e71d70e2505ea4e1a1443ad9d.svg";
export { ForwardRef as ReactComponent };